module.exports = __webpack_public_path__ + "media/images/pic/testimonials/kuba-cf30f6e6a5ab0d0360a844461e052511.jpg";